---
meta:
  - title: Cómo funciona cada paso - IUSPRO Docs
  - description: Entienda qué hace cada parte de un agente y cuándo conviene usarla.
---

# Cómo funciona cada paso

Un agente divide el trabajo en partes.

Piense en ello como cuando un asunto pasa por varias manos dentro de una oficina:

- primero se recibe la información
- luego se estudia
- después se ordena
- luego se redacta
- al final se revisa o se traduce

## Entrada

Es la parte donde la persona aporta la información del asunto.

Aquí puede pedir:

- texto
- archivos
- uno o varios valores

Todavía no hay análisis. Solo se recoge el material inicial.

## Instrucción

Sirve para pedir un trabajo general sobre lo que ya se produjo antes.

Úselo para:

- resumir
- ordenar ideas
- convertir un análisis en argumentos
- cambiar tono o formato

## Razonamiento con búsqueda legal (Auri)

Sirve para la parte más jurídica del trabajo.

Úselo cuando quiere que el sistema piense el asunto como abogado:

- qué normas aplican
- qué enfoque conviene
- qué puntos son fuertes o débiles
- qué apoyo legal tiene la posición

## Búsqueda en la web

Busca en la web y devuelve fuentes con enlaces.

Úselo cuando necesita:

- páginas oficiales
- información pública reciente
- fuentes externas al sistema

Este paso no está pensado para hablar mucho. Está pensado para traerle material útil para seguir trabajando.

## Redactor

Crea un documento real en el Redactor.

Úselo cuando el objetivo ya no es solo analizar, sino dejar un escrito.

Por ejemplo:

- una demanda
- una contestación
- una respuesta a prevención
- una carta o documento formal

Este paso puede usar:

- una instrucción libre
- un formato
- archivos de referencia
- un borrador base

Si después quiere seguir trabajando ese documento, lo hará desde el propio chat del Redactor.

## Revision

Revisa el resultado anterior usando un manual existente.

Úselo cuando quiere pasar el documento por una revisión más estandarizada.

Por ejemplo:

- estructura mínima
- reglas de calidad interna
- requisitos de un tipo de escrito

## Traducción

Traduce el resultado anterior al idioma elegido.

Úselo al final cuando necesita entregar una versión en otro idioma.

Si la parte anterior fue Redactor, la traducción actualiza ese mismo documento en vez de crear otro.

## Cómo elegir bien las partes

Use las menos posibles, pero que sí reflejen su forma real de trabajar.

Una guía sencilla es:

- análisis jurídico: **Auri**
- ordenar o convertir texto: **Instrucción**
- documento final: **Redactor**
- control de calidad: **Revision**
- idioma final: **Traducción**

## Siguiente lectura

- Aprenda [cómo ejecutar un agente y leer sus resultados](/guias/agentes-ejecutar-y-leer-resultados)
